interface DragConstraints {
  viewportWidth: number;
  viewportHeight: number;
  modalHeight: number;
  headerHeight: number;
}

interface Position {
  x: number;
  y: number;
}

export function calculateConstrainedPosition(
  newX: number,
  newY: number,
  { viewportWidth, viewportHeight, modalHeight, headerHeight }: DragConstraints
): Position {
  const maxOffsetX = viewportWidth / 2;
  const minOffsetY = -viewportHeight / 2 + modalHeight / 2 - headerHeight / 2;
  const maxOffsetY = viewportHeight / 2 + modalHeight / 2 - headerHeight / 2;

  return {
    x: Math.max(-maxOffsetX, Math.min(maxOffsetX, newX)),
    y: Math.max(minOffsetY, Math.min(maxOffsetY, newY))
  };
}

export function buildTranslateStyle(x: number, y: number): string {
  return `translate(calc(-50% + ${x.toString()}px), calc(-50% + ${y.toString()}px))`;
}

export const INITIAL_TRANSFORM = 'translate(calc(-50% + 0px), calc(-50% + 0px))';
